module.exports = __webpack_public_path__ + "img/shape-bg-login.3f416e4a.svg";